// Shared leaf UI primitives used by App.js + extracted page modules.
import React from "react";

export function Stat({ label, value, mono }) {
  return (
    <div className="card p-4">
      <div className="label-upper mb-1">{label}</div>
      <div className={`text-lg font-semibold ${mono ? "font-mono tabular" : ""}`}>{value}</div>
    </div>
  );
}
